import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwAutocompleteModule } from '@cdw-ae/common-ui-components-autocomplete';
import { CdwFilteredTreePickerModule } from '@cdw-ae/common-ui-components-filtered-tree-picker';
import { CdwSelectModule } from '@cdw-ae/common-ui-components-select';
import { CommonUiComponentsTextInputModule } from '@cdw-ae/common-ui-components-text-input';

import { CdwBulkFieldUpdateComponent } from './cdw-bulk-field-update.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialLibraryModule,
    CommonUiComponentsTextInputModule,
    CdwAutocompleteModule,
    CdwSelectModule,
    CdwFilteredTreePickerModule,
    TextFieldModule,
  ],
  declarations: [CdwBulkFieldUpdateComponent],
  exports: [CdwBulkFieldUpdateComponent],
})
export class CommonUiComponentsBulkFieldUpdateModule {}
